import Announcements from '@/pages/Announcements';

export default function MobileAnnouncementsScreen() {
  return <Announcements />;
}

